export const firstLetterUppercase = (text: string): string => {
  return text
    .split(' ')
    .map(part => part[0].toUpperCase() + part.substring(1))
    .join(' ');
};
